import api from "./axios";

class ServiceUser {
  requestConfig(idEmpresa) {
    return idEmpresa ? { params: { idEmpresa } } : {};
  }

  async save(user, idEmpresa) {
    const { data } = await api.post("/user", user, this.requestConfig(idEmpresa))
    return data
  }

  async findCorporations() {
    const { data } = await api.get("/user/find/corporations")
    return data
  }

  async update(id, user, idEmpresa) {
    await api.put(`/user/${id}`, user, this.requestConfig(idEmpresa))
  }

  async updatePermissions(id, permission, idEmpresa) {
    await api.patch(`/user/${id}`, permission, this.requestConfig(idEmpresa))
  }

  async delete(id, idUserGestao, idEmpresa) {
    await api.delete(`/user/${id}/${idUserGestao}`, this.requestConfig(idEmpresa))
  }

  async findById(id, idEmpresa) {
    const { data } = await api.get(`/user/${id}`, this.requestConfig(idEmpresa))
    return data
  }

  async findIntegrationsById(id, idEmpresa) {
    const { data } = await api.get(`/user/integrations/${id}`, this.requestConfig(idEmpresa))
    return data
  }

  async findAll() {
    const { data } = await api.get("/user/find/in/gestao")
    return data
  }

  async findUnserInGestao() {
    const { data } = await api.get("/user/find/user/in/gestao")
    return data
  }

  async findUserLevelByIdUserGestao(id) {
    const { data } = await api.get(`/user/user-level/${id}`)
    return data
  }

  async updatedCardMachine(id, cardMachines, idEmpresa) {
    await api.patch(`/user/integrations/${id}`, { cardMachines }, this.requestConfig(idEmpresa))
  }
}

export default new ServiceUser()
